// Sofort ausführbarer Code (IIFE)
(function() {
  // Nur auf Produktseiten ausführen
  if (!window.location.pathname.includes('/products/')) return;
  
  // Option 1: Direkt ausführen, ohne auf DOM-Laden zu warten
  fixFirstImage();
  
  // Option 2: Auch beim DOM-Laden ausführen (als Fallback)
  document.addEventListener('DOMContentLoaded', fixFirstImage);
  
  // Option 3: Auch nach vollständigem Laden ausführen (für absolut sicheres Ergebnis)
  window.addEventListener('load', fixFirstImage);
  
  function fixFirstImage() {
    // Finde alle relevanten Elemente
    const productGallery = document.querySelector('.product-gallery__carousel');
    const firstMediaItem = document.querySelector('.product-gallery__media[data-media-position="1"]');
    
    if (productGallery && typeof productGallery.select === 'function') {
      // Sofort erste Position auswählen
      productGallery.select(0, { instant: true });
    }
    
    // Falls es sich um ein Media Grid handelt
    if (firstMediaItem) {
      // Alle Medien-Elemente finden
      const allMediaItems = document.querySelectorAll('.product-gallery__media');
      
      // Ersten hervorheben, andere verstecken
      allMediaItems.forEach(media => {
        const isFirst = media.getAttribute('data-media-position') === '1';
        media.classList.toggle('is-selected', isFirst);
        media.setAttribute('aria-hidden', isFirst ? 'false' : 'true');
      });
    }
  }
  
  // Zusätzlich einen MutationObserver hinzufügen, um sofort auf Änderungen zu reagieren
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          fixFirstImage();
        }
      });
    });
    
    // Das ganze Dokument beobachten
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Optional: Observer nach einiger Zeit wieder beenden
    setTimeout(function() {
      observer.disconnect();
    }, 3000); // Nach 3 Sekunden stoppen
  }
})();